import { render, staticRenderFns } from "./downlist.vue?vue&type=template&id=8cbf817a&"
import script from "./downlist.vue?vue&type=script&lang=js&"
export * from "./downlist.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports